import type { MigrationStrategies } from "./_types/migration-strategies";

export const EPOCUS_CONSENT_DOCUMENT_MIGRATION_STRATEGIES: MigrationStrategies =
  {};
